import { useUnit } from 'effector-react';
import { Backdrop, CircularProgress } from '@mui/material';
import { $isLoading } from '../../../model';

export const Loader = () => {
  const isLoading = useUnit($isLoading);

  return (
    <Backdrop open={isLoading}>
      <CircularProgress />
    </Backdrop>
  );
};
